import React from 'react'
import { Input } from 'antd'

import { FormErrorMessage } from 'components/reusables/formErrorMessage'
import { RequiredFieldLabel } from 'components/reusables/requiredFieldLabel'
import { useTranslationRankmi } from 'helpers/translations.helper'
import { prefix } from '../common'
import { Field, InputWrapper } from './styled'

interface EstimatedDurationInputProps {
  value: number | string
  onChange: (value: string) => void
  error?: string
  required?: boolean
  disabled?: boolean
}

const toDisplayValue = (value: number | string): string => {
  if (value === '' || value === undefined || value === null) return ''
  return String(value)
}

export const EstimatedDurationInput: React.FC<EstimatedDurationInputProps> = ({
  value,
  onChange,
  error = '',
  required = false,
  disabled = false,
}) => {
  const t = useTranslationRankmi({
    prefix: `${prefix}.courseFields.duration`,
  })

  return (
    <Field>
      <RequiredFieldLabel required={required}>{t('label')}</RequiredFieldLabel>
      <InputWrapper $hasError={!!error}>
        <Input
          name="hours"
          type="number"
          min={0}
          step={0.5}
          disabled={disabled}
          suffix={t('suffix')}
          value={toDisplayValue(value)}
          onChange={(event) => onChange(event.target.value)}
        />
      </InputWrapper>
      {error ? <FormErrorMessage message={error} /> : null}
    </Field>
  )
}
